export const sizeInMB = byte => (byte / (1024 * 1024)).toFixed(2);
export const sizeInKB = byte => (byte / 1024).toFixed(2);
